import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { APP_PAGES_CONFIG } from 'constants/routes';

export const useSpaNavigation = () => {
  const router = useRouter();

  return useMemo(() => {
    return {
      push: async (
        pageToNavigate: keyof typeof APP_PAGES_CONFIG,
        additionalQuery?: string | Record<string, string>,
      ) => {
        const params = new URLSearchParams(window?.location?.search);
        const baseQuery: Record<string, string> = {};

        params.forEach((value, key) => {
          baseQuery[key] = value;
        });

        let extra: Record<string, string> = {};

        if (typeof additionalQuery === 'string' && additionalQuery.trim()) {
          const raw = additionalQuery.startsWith('?') ? additionalQuery.slice(1) : additionalQuery;
          const params = new URLSearchParams(raw);
          params.forEach((value, key) => {
            extra[key] = value;
          });
        } else if (additionalQuery && typeof additionalQuery === 'object') {
          extra = additionalQuery;
        }

        const query = { ...baseQuery, ...extra };

        return router.push(
          {
            pathname: pageToNavigate,
            query,
          },
          {
            pathname: APP_PAGES_CONFIG[pageToNavigate].web,
            query,
          },
          { shallow: true },
        );
      },
      prefetch: async (pageToNavigate: keyof typeof APP_PAGES_CONFIG) => {
        return router.prefetch(pageToNavigate, APP_PAGES_CONFIG[pageToNavigate].web);
      },
    };
  }, [router]);
};
